import { type ComponentType } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { type IWorkspaceSelector } from '@principle-theorem/ng-auth';
import {
  OrganisationWorkspaceSelectorComponent,
  PartnerWorkspaceSelectorComponent,
} from '@principle-theorem/ng-principle';

@Component({
  selector: 'pr-workspaces',
  templateUrl: './workspaces.component.html',
  styleUrls: ['./workspaces.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkspacesComponent {
  workspaceSelectors: ComponentType<IWorkspaceSelector>[] = [
    OrganisationWorkspaceSelectorComponent,
    PartnerWorkspaceSelectorComponent,
  ];
}
